/* Header section behaviour — mobile nav drawer, account dropdown, sticky state.
   Self-contained, no bootstrap/jQuery/ella.js dependency. */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var header = document.getElementById('WB-header');
    var toggle = document.getElementById('WB-header-nav-toggle');
    var nav = document.getElementById('WB-header-nav');
    var overlay = document.getElementById('WB-header-overlay');

    function closeNav() {
      if (!nav) return;
      nav.classList.remove('is-open');
      if (overlay) overlay.hidden = true;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('WB-header-nav-locked');
    }

    function openNav() {
      if (!nav) return;
      nav.classList.add('is-open');
      if (overlay) overlay.hidden = false;
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('WB-header-nav-locked');
    }

    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        if (nav.classList.contains('is-open')) {
          closeNav();
        } else {
          openNav();
        }
      });
    }

    if (overlay) {
      overlay.addEventListener('click', closeNav);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeNav();
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 991) closeNav();
    });

    // Let mobile taps expand dropdown submenus instead of following the link.
    if (nav) {
      var dropdownLinks = nav.querySelectorAll('.site-nav > li.dropdown > a');
      dropdownLinks.forEach(function (link) {
        link.addEventListener('click', function (event) {
          if (window.innerWidth <= 991) {
            var parent = link.parentElement;
            var isOpen = parent.classList.toggle('open');
            if (isOpen) event.preventDefault();
          }
        });
      });
    }

    // Account dropdown
    var accountToggle = document.querySelector('.WB-header__account-toggle');
    var accountMenu = document.getElementById('WB-header-account-menu');

    if (accountToggle && accountMenu) {
      accountToggle.addEventListener('click', function (event) {
        event.stopPropagation();
        var isOpen = accountMenu.classList.toggle('is-open');
        accountToggle.setAttribute('aria-expanded', String(isOpen));
      });

      document.addEventListener('click', function (event) {
        if (!accountMenu.contains(event.target) && !accountToggle.contains(event.target)) {
          accountMenu.classList.remove('is-open');
          accountToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    // Sync the duplicate cart count badges (sticky nav bar + mobile topbar)
    // with the main one (ajax cart scripts only ever update the original #cartCount).
    var cartCount = document.getElementById('cartCount');
    var navCartCount = document.getElementById('WB-header-nav-cart-count');
    var topbarCartCount = document.getElementById('WB-header-topbar-cart-count');
    if (cartCount && 'MutationObserver' in window) {
      var syncTargets = [navCartCount, topbarCartCount].filter(Boolean);
      if (syncTargets.length) {
        var syncCartCount = function () {
          syncTargets.forEach(function (target) {
            if (target.textContent !== cartCount.textContent) {
              target.textContent = cartCount.textContent;
            }
          });
        };
        syncCartCount();
        new MutationObserver(syncCartCount).observe(cartCount, {
          childList: true,
          subtree: true,
          characterData: true,
        });
      }
    }

    // Mobile search reveal panel — topbar search-toggle opens a slide-down
    // panel (height animated via JS since CSS can't transition to "auto"),
    // closable via its own close button, tapping outside, or Escape.
    var searchToggle = document.getElementById('WB-header-search-toggle');
    var searchPanel = document.getElementById('WB-header-mobile-search-panel');
    var searchClose = document.getElementById('WB-header-mobile-search-close');
    var searchInput = document.getElementById('WB-header-mobile-search-input');

    function closeSearchPanel() {
      if (!searchPanel || !searchPanel.classList.contains('is-open')) return;
      searchPanel.style.maxHeight = '0px';
      searchPanel.classList.remove('is-open');
      if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
    }

    function openSearchPanel() {
      if (!searchPanel) return;
      searchPanel.classList.add('is-open');
      searchPanel.style.maxHeight = searchPanel.scrollHeight + 'px';
      if (searchToggle) searchToggle.setAttribute('aria-expanded', 'true');
      if (searchInput) searchInput.focus();
    }

    if (searchToggle && searchPanel) {
      searchToggle.addEventListener('click', function (event) {
        event.stopPropagation();
        if (searchPanel.classList.contains('is-open')) {
          closeSearchPanel();
        } else {
          openSearchPanel();
        }
      });
    }

    if (searchClose) {
      searchClose.addEventListener('click', closeSearchPanel);
    }

    document.addEventListener('click', function (event) {
      if (
        searchPanel &&
        searchPanel.classList.contains('is-open') &&
        !searchPanel.contains(event.target) &&
        (!searchToggle || !searchToggle.contains(event.target))
      ) {
        closeSearchPanel();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeSearchPanel();
    });

    window.addEventListener('resize', function () {
      if (searchPanel && searchPanel.classList.contains('is-open')) {
        searchPanel.style.maxHeight = searchPanel.scrollHeight + 'px';
      }
      if (window.innerWidth > 991) closeSearchPanel();
    });

    // Sticky header — pins the topbar + nav bar (stacked, topbar on top) to
    // the viewport once the sentinel (placed just before .WB-header__main-inner,
    // inside .WB-header__main) scrolls out of view, i.e. the instant the
    // logo/search row would otherwise touch the viewport top. Mirrors the
    // legacy "header-bottom.on" swap (which kept topBar + navigation +
    // infoBar together as one fixed unit). The information bar is a
    // separate section, so it's picked up by id and synced to the same
    // stuck state. A body class drives a single padding-top on
    // .main-content (sized to the live combined height of the fixed
    // cluster), so page content never jumps or gets covered, at any screen
    // size.
    if (header && header.dataset.sticky === 'true') {
      var topbar = header.querySelector('.WB-header__topbar');
      var sentinel = header.querySelector('.WB-header__sticky-sentinel');
      var infobar = document.getElementById('WB-infobar');
      var root = document.documentElement;

      function updateOffsets() {
        var topbarHeight = topbar ? topbar.offsetHeight : 0;
        var navHeight = nav ? nav.offsetHeight : 0;
        var infobarHeight = infobar ? infobar.offsetHeight : 0;
        root.style.setProperty('--wb-header-topbar-h', topbarHeight + 'px');
        root.style.setProperty('--wb-header-nav-h', navHeight + 'px');
        root.style.setProperty('--wb-header-stuck-h', (topbarHeight + navHeight + infobarHeight) + 'px');
      }

      function setStuck(stuck) {
        // Desktop-only feature — the off-canvas drawer handles mobile nav instead.
        var shouldStick = stuck && window.innerWidth > 991;
        header.classList.toggle('is-stuck', shouldStick);
        if (infobar) infobar.classList.toggle('is-stuck', shouldStick);
        document.body.classList.toggle('WB-header-is-stuck', shouldStick);
        updateOffsets();
      }

      updateOffsets();

      if ('ResizeObserver' in window) {
        if (topbar) new ResizeObserver(updateOffsets).observe(topbar);
        if (nav) new ResizeObserver(updateOffsets).observe(nav);
        if (infobar) new ResizeObserver(updateOffsets).observe(infobar);
      }

      window.addEventListener('resize', function () {
        updateOffsets();
        if (window.innerWidth <= 991) setStuck(false);
      });

      if (sentinel && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            setStuck(!entries[0].isIntersecting);
          },
          { threshold: 0 }
        );
        observer.observe(sentinel);
      }
    }
  });
})();
